import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue';
import Registro from '@/views/Registro.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import Dashboard from '@/views/Dashboard.vue';
import CbcAnalyzer from '@/views/CbcAnalyzer.vue';
import BmpAnalyzer from '@/views/BmpAnalyzer.vue';
import abgAnalyzer from '@/views/abgAnalyzer.vue';
import maestros from '@/views/maestros.vue';
import lipidAnalyzer from '@/views/lipidAnalyzer.vue';
import DesEnfermedades from '@/views/DesEnfermedades.vue'
import lipidAnalyzer_calculator from '@/views/lipidAnalyzer_calculator.vue';
import liver_enzymes from '@/views/liver_enzymes.vue';
import EditUser from '../views/EditUser.vue';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/Registro',
    name: 'Registro',
    component: Registro
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true } // Añadimos esta meta para indicar que esta ruta requiere autenticación
  },
  {
    path: '/CbcAnalyzer',
    name: 'CbcAnalyzer',
    component: CbcAnalyzer,// Añadimos esta meta para indicar que esta ruta requiere autenticación
  },
  {
    path: '/BmpAnalyzer',
    name: 'BmpAnalyzer',
    component: BmpAnalyzer,// Añadimos esta meta para indicar que esta ruta requiere autenticación
  },
  { 
    path: '/abgAnalyzer',
    name: 'abgAnalyzer',
    component: abgAnalyzer,// Añadimos esta meta para indicar que esta ruta requiere autenticación
  },
  { 
    path: '/maestros',
    name: 'maestros',
    component: maestros,// Añadimos esta meta para indicar que esta ruta requiere autenticación
  },
  { 
    path: '/lipidAnalyzer',
    name: 'lipidAnalyzer',
    component: lipidAnalyzer,// Añadimos esta meta para indicar que esta ruta requiere autenticación
  },
  { 
    path: '/DesEnfermedades',
    name: 'DesEnfermedades',
    component: DesEnfermedades,// Añadimos esta meta para indicar que esta ruta requiere autenticación
  },
  { 
    path: '/lipidAnalyzer_calculator',
    name: 'lipidAnalyzer_calculator',
    component: lipidAnalyzer_calculator,// Añadimos esta meta para indicar que esta ruta requiere autenticación
  },
    { 
    path: '/liver_enzymes',
    name: 'liver_enzymes',
    component: liver_enzymes,// Añadimos esta meta para indicar que esta ruta requiere autenticación
  },
  {
  path: "/usuarios/editar/:id",
  name: "edit-user",
  component: EditUser,
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Ruta de protección para las rutas que requieren autenticación
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !localStorage.getItem('auth_token')) {
    // Si la ruta requiere autenticación y no hay un token, redirige al login
    next({ name: 'Login' });
  } else {
    next(); // Si la ruta no requiere autenticación o el usuario está autenticado, continúa
  }
});

export default router;
